import { DetailsDisclosure } from '@/scripts/interactive-defer/details-disclosure'
import {
	closeAllHeaderMenus,
	getAttributeOrUndefined,
	onKeyUpEscape,
	qsOptional,
	qsRequired,
} from '@/scripts/core/global'
import { type StickyHeader } from '@/scripts/theme/sticky-header'
import { SELECTORS } from '@/scripts/core/global'
import { toggleHeaderColorScheme } from '@/scripts/core/cart-functions'

export class HeaderMenu extends DetailsDisclosure {
	static override htmlSelector = 'header-menu'
	header: StickyHeader | null
	hoverSummary?: HTMLElement
	detailsId?: string
	constructor() {
		super()
		this.header = qsRequired<StickyHeader>(SELECTORS.headerWrapper)
		this.hoverSummary = qsOptional('summary[data-summary-hover="on"]', this)
		this.detailsId = getAttributeOrUndefined('id', this.mainDetailsToggle)
		this.initHoverSummary()
	}

	initHoverSummary() {
		if (!this.hoverSummary || !this.detailsId) return

		this.hoverSummary.addEventListener('click', (event) => {
			const el = this.hoverSummary
			if (!el) return // element has been removed from dom somehow lol
			const isExpanded = el.getAttribute('aria-expanded') === 'true'
			const parentUrl = getAttributeOrUndefined(
				'data-summary-parent-url',
				el
			)
			if (event.type === 'click' && isExpanded && parentUrl) {
				window.location.href = parentUrl
			}

			document.body.classList.add('megamenu-open')
			toggleHeaderColorScheme('menu')
			void window.Ucoast.mediaManager.loadAllInContainer(
				this.mainDetailsToggle
			)
			window.setTimeout(() => {
				void window.Ucoast.mediaManager.loadAllInContainer(
					this.mainDetailsToggle
				)
			}, 3)
		})

		this.hoverSummary.addEventListener('mouseenter', (_) => {
			document.body.classList.add('megamenu-open')
			toggleHeaderColorScheme('menu')
			void window.Ucoast.mediaManager.loadAllInContainer(
				this.mainDetailsToggle
			)
			const openMenuId = window.Ucoast.openMenuId
			if (openMenuId && openMenuId === this.detailsId) return
			if (openMenuId) {
				closeAllHeaderMenus(true)
			}
			window.Ucoast.openMenuId = this.detailsId
			this.mainDetailsToggle.setAttribute('open', '')
			this.animations?.forEach((animation) => animation.play())
			this.hoverSummary?.setAttribute('aria-expanded', 'true')
			void window.Ucoast.mediaManager.loadAllInContainer(
				this.mainDetailsToggle
			)
		})

		this.mainDetailsToggle.addEventListener('keyup', (e) => {
			toggleHeaderColorScheme('starting')
			document.body.classList.remove('megamenu-open')
			onKeyUpEscape(e)
		})
	}

	override onToggle() {
		if (!this.header) return
		this.header.preventHide = this.mainDetailsToggle.open

		if (
			document.documentElement.style.getPropertyValue(
				'--header-bottom-position-desktop'
			) !== ''
		)
			return
		document.documentElement.style.setProperty(
			'--header-bottom-position-desktop',
			`calc(${this.header.getBoundingClientRect().bottom} * var(--ax))`
		)
	}
}
